import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
export var eventKey = 'retailer_team_management-copy_link_button-click';
/**
 * Copy link button in share modal click
 */ export function trackRetailerTeamManagementCopyLinkButtonClick(customParameterToken) {
    return trackClientEvent({
        eventKey: eventKey,
        realTimeTracking: false,
        parameters: {
            customParameterToken: customParameterToken
        }
    });
}
